import { Mail } from 'lucide-react';
import BoitesMail from '../components/BoitesMail';
import { useAuth } from '../hooks/useAuth';

/**
 * Les boîtes mail de l'association, sur un écran à elles.
 *
 * Elles occupaient le bas de « Mon espace », après les coordonnées, les
 * missions et le reste : on venait corriger son numéro de téléphone et l'on
 * tombait sur la messagerie du bureau. Un écran qui répond à trop de
 * questions ne répond bien à aucune.
 *
 * Surtout, une boîte de fonction se consulte plusieurs fois par semaine —
 * c'est là qu'arrivent les demandes de réservation et les réponses des
 * sponsors. Ce qui se consulte souvent mérite son entrée au menu, pas un
 * défilement.
 */
export default function MessageriePage() {
  const { user, isLoading } = useAuth();

  if (isLoading) return null;

  return (
    <div className="p-4 lg:p-0 space-y-5 pb-24 lg:pb-0">
      <div className="flex items-center gap-3">
        <Mail className="w-7 h-7 text-primary-700 shrink-0" />
        <div>
          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 dark:text-gray-100">
            Messagerie de l'association
          </h1>
          <p className="text-sm lg:text-base text-gray-600 dark:text-gray-400">
            Les boîtes de fonction : président, secrétaire, trésorier, contact.
          </p>
        </div>
      </div>

      {user ? (
        <BoitesMail />
      ) : (
        <p className="card text-sm text-gray-600 dark:text-gray-400">
          Connectez-vous pour ouvrir la messagerie.
        </p>
      )}
    </div>
  );
}
